<template>
    <div>
        <HeadersWebsite header="ช่องทางการติดต่อ" :img_header="header_image" link_back="managewebsite"/>
        <ManageContact/>
    </div>
</template>

<script>
    import HeaderImage from "@/assets/call-center.png"
    import HeadersWebsite from "@/components/admin/manage_website/menu_website/HeadersWebsite.vue";
    import ManageContact from "@/components/admin/manage_website/ManageContact.vue";
    export default {
        name: "ContactPage",
        components: {
            ManageContact,
            HeadersWebsite
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
